import { ProjectItemTypeConstant, ProjectItemTypeNameConstant } from 'constants/code.constant';
import { ModalNameConstant } from 'constants/modal.constant';
import { format } from 'date-fns';
import useConsultingAssign from 'hooks/useConsultingAssign';
import useEventAssign from 'hooks/useEventAssign';
import useModal from 'hooks/useModal';
import useProjectItem from 'hooks/useProjectItem';
import MainLayout from 'layouts/MainLayout';
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const ProjectItemDetailConsultingForm = React.memo(({ projectId, projectItemId }) => {
  const { openModal } = useModal();

  const { useGetConsultingAssignList } = useConsultingAssign();

  const { list: consultingAssignList, totalCount } = useGetConsultingAssignList({ projectItemId });

  const openClientSelectModal = ({ assignedClientIds }) => {
    openModal(ModalNameConstant.PROJECT_ITEM_CLIENT_SELECT, {
      projectId,
      selectedClientIds: assignedClientIds,
      showSelectedOnly: true,
    });
  };

  return (
    <>
      <div className="page-header">컨설팅 목록 {totalCount}개</div>
      {consultingAssignList.map((item, index) => (
        <div key={index}>
          <div className="page-card">
            <div className="table-search-wrap detail-form-wrap">
              <div>
                <label>컨설턴트</label>
                <p className="text">{item.consultantName}</p>
              </div>
              <div>
                <label>컨설팅명</label>
                <p className="text">{item.consultingName}</p>
              </div>
              <div>
                <label>참여 기업 수</label>
                <p className="text">{item.assignedClientIds.length}</p>
              </div>
              <div>
                <label>컨설턴트가 수행해야 하는 일정 횟수</label>
                <p className="text">{item.requiredScheduleCount}</p>
              </div>
              {item.assignedClientIds.length > 0 ? (
                <div>
                  <button
                    className="btn edit-btn"
                    type="button"
                    onClick={() => openClientSelectModal({ assignedClientIds: item.assignedClientIds })}
                  >
                    참여 기업 보기
                  </button>
                </div>
              ) : (
                <br />
              )}
              <div>
                <label>등록일시</label>
                <p className="text">{format(item.createdAt, 'yyyy-MM-dd HH:mm:ss')}</p>
              </div>
            </div>
          </div>
          <br />
        </div>
      ))}
    </>
  );
});

const ProjectItemDetailEventForm = React.memo(({ projectId, projectItemId }) => {
  const { openModal } = useModal();

  const { useGetEventAssignList } = useEventAssign();

  const { list: eventAssignList, totalCount } = useGetEventAssignList({ projectItemId });

  const openClientSelectModal = ({ assignedClientIds }) => {
    openModal(ModalNameConstant.PROJECT_ITEM_CLIENT_SELECT, {
      projectId,
      selectedClientIds: assignedClientIds,
      showSelectedOnly: true,
    });
  };

  return (
    <>
      <div className="page-header">행사 목록 {totalCount}개</div>
      {eventAssignList.map((item, index) => (
        <div key={index}>
          <div className="page-card">
            <div className="table-search-wrap detail-form-wrap">
              <div>
                <label>행사명</label>
                <p className="text">{item.eventName}</p>
              </div>
              <div>
                <label>장소</label>
                <p className="text">{item.place}</p>
              </div>
              <div>
                <label>참여 기업 수</label>
                <p className="text">{item.assignedClientIds.length}</p>
              </div>
              <div>
                <label>기간</label>
                <p className="text">{item.period.join(', ')}</p>
              </div>
              {item.assignedClientIds.length > 0 ? (
                <div>
                  <button
                    className="btn edit-btn"
                    type="button"
                    onClick={() => openClientSelectModal({ assignedClientIds: item.assignedClientIds })}
                  >
                    참여 기업 보기
                  </button>
                </div>
              ) : (
                <br />
              )}
              <div>
                <label>등록일시</label>
                <p className="text">{format(item.createdAt, 'yyyy-MM-dd HH:mm:ss')}</p>
              </div>
            </div>
          </div>
          <br />
        </div>
      ))}
    </>
  );
});

const OrganizerProjectItemDetail = () => {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId');
  const projectItemId = searchParams.get('projectItemId');

  const { useGetProjectItem } = useProjectItem();
  const { projectItemInfo } = useGetProjectItem(projectItemId);

  if (!projectItemInfo) return;

  return (
    <MainLayout>
      <div className="page-header">과업 상세</div>
      <div className="page-card">
        <div className="table-search-wrap detail-form-wrap">
          <div>
            <label>과업명</label>
            <p className="text">{projectItemInfo.itemName}</p>
          </div>
          <div>
            <label>유형</label>
            <p className="text">{ProjectItemTypeNameConstant[projectItemInfo.type]}</p>
          </div>
          <div>
            <label>전체 일정 횟수</label>
            <p className="text">{projectItemInfo.maxScheduleCount}</p>
          </div>
          <div>
            <label>담당자</label>
            <p className="text">{projectItemInfo.name}</p>
          </div>
          <div>
            <label>등록일시</label>
            <p className="text">{format(projectItemInfo.createdAt, 'yyyy-MM-dd HH:mm:ss')}</p>
          </div>
        </div>
      </div>
      <br />
      <Link to={`/organizer/project/detail?projectId=${projectId}`}>
        <button className="btn success-btn" type="button">
          과업 목록
        </button>
      </Link>
      <br />
      <br />
      {projectItemInfo.type === ProjectItemTypeConstant.CONSULTING && (
        <ProjectItemDetailConsultingForm projectId={projectId} projectItemId={projectItemId} />
      )}
      {projectItemInfo.type === ProjectItemTypeConstant.EVENT && (
        <ProjectItemDetailEventForm projectId={projectId} projectItemId={projectItemId} />
      )}
    </MainLayout>
  );
};

export default OrganizerProjectItemDetail;
